import { CustomerType, PersonType } from "@hubcapp/types";

export const hasDitLearnerType = (
  customerTypes: Pick<CustomerType, "type">[],
): boolean => customerTypes.some(ct => ct.type === PersonType.Dit);
